angular.module('tf.services')

    .factory('FarmerService', ['HttpService','$q','UrlEncodingService','$stateParams','WebSocketService','$rootScope','Session','DemoFarmerService',
            function (HttpService, $q, UrlEncodingService, $stateParams, WebSocketService, $rootScope, Session, DemoFarmerService) {
        var service = {};

        service.getFarmers = function(){
            var defer = $q.defer();
            $rootScope.$broadcast('working',true);
            HttpService.get('farmer/').then(function (response) {
                $rootScope.$broadcast('working',false);
                var farmers = response.data;
                if(_.includes(['dok@tf.com', 'dokydok@gmail.com'],Session.user.getEmail())) {
                    farmers.push(DemoFarmerService.farmer);
                }
                defer.resolve(farmers);
            });
            return defer.promise;

        };

        service.current = function(){
            if ($stateParams.path) {
                var decoded = UrlEncodingService.get($stateParams.path);
                return decoded;
            }
        };


        service.fid = function(){
            return service.current().fid;
        };

        service.path = function(){
            return service.current().path;
        };

        service.type = function(){
            return service.current().type;
        };

        service.subscribe = function(shared_farmer){
            WebSocketService.subscribe(shared_farmer.farmer.fid + "-client");
        };

        return service;
    }])
;
